module.exports = __webpack_public_path__ + "img/2023big32.881d8a6a.png";